// extracted by mini-css-extract-plugin
export default {"box":"future_QOBTTiThVyk4"};